__turbopack_context__.v({
  "root": "GlobalFansLeaderboard-module-scss-module__AWuyfa__root",
  "toolbar": "GlobalFansLeaderboard-module-scss-module__AWuyfa__toolbar",
});
